export default "__VITE_ASSET__BSsS3$24__"